<template>
  <svg
    viewBox="0 0 259 317"
    xmlns="http://www.w3.org/2000/svg"
    class="svg-icon icon-angle"
    :class="direction"
  >
    <path
      d="M138.59,153.126l-53.306,-53.306c-3.172,-3.173 -3.172,-8.324 0,-11.497l11.496,-11.496c3.173,-3.173 8.324,-3.173 11.497,-0l58.738,58.738c0.111,0.099 0.219,0.201 0.325,0.307l11.496,11.497c1.589,1.588 2.382,3.673 2.38,5.757c0.002,2.084 -0.791,4.168 -2.38,5.757l-11.496,11.496c-0.106,0.106 -0.214,0.208 -0.325,0.307l-58.738,58.739c-3.173,3.172 -8.324,3.172 -11.497,-0l-11.496,-11.497c-3.172,-3.172 -3.172,-8.324 0,-11.496l53.306,-53.306Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAngle",
  props: ["direction"]
};
</script>

<style lang="scss" scoped>
.icon-angle.up {
  transform: rotate(-90deg);
}
.icon-angle.left {
  transform: rotate(180deg);
}
.icon-angle.down {
  transform: rotate(90deg);
}
</style>
